import { IColumns } from '../../../../../components/Dashboard/TableSmall'

export interface IData {
  columns: IColumns[]
}

export const data: IData = {
  columns: [
    {
      id: 'name',
      label: 'NAME',
    },
    {
      id: 'dateReferred',
      label: 'DATE REFERRED',
    },
    {
      id: 'dateApproved',
      label: 'DATE APPROVED',
    },
    {
      id: 'status',
      label: 'STATUS',
    },
  ],
}
